export default "__VITE_ASSET__CnkEASZF__"